import type { GetJobsRequest } from "../../types/company-job";
import type { CompanyJobRepository } from "../../repositories/company/company-job-repository";
import { AppError } from "../../../shared/utils/error-handler";

export class CompanyJobUseCase {
  constructor(private companyJobRepository: CompanyJobRepository) {}

  async getJobs(request: GetJobsRequest): Promise<any> {
    try {
      return await this.companyJobRepository.getJobs(request);
    } catch (error) {
      throw new AppError(
        String(error) || "작업을 불러오지 못했습니다.",
        "JOBS_GET_FAILED",
        error,
      );
    }
  }
}